module.exports = __webpack_public_path__ + "img/img41.0c1b77af.png";